var exports = {
  "R": "formElementsContainer__uAB4Ti",
  "J": "markdownElementWrapper__AHCuJF",
};

module.exports = exports;
